// src/utils/pagePermissions.js
export const pagePermissions = {
  admin: {
    dashboard: true,
    users: true,
    departments: true,
    leads: true,
    quotations: true,
    reports: true,
    settings: true
  },
  manager: {
    dashboard: true,
    users: false,
    departments: false,
    leads: true,
    quotations: true,
    reports: true,
    settings: false
  },
  user: {
    dashboard: true,
    users: false,
    departments: false,
    leads: true,
    quotations: true,
    reports: false,
    settings: false
  }
};

// Check if user can access a page
export const canAccessPage = (userRole, page) => {
  return pagePermissions[userRole]?.[page] || false;
};